import { useState, useEffect } from 'react';
import { Typography, Divider, TextField, Button } from '@mui/material';
import tenant from '@/services/TenantService';
import { Box } from '@mui/system';

const WarehousePrinterSettings = ({ app, deployment, onSave }) => {
  const [printerId, setPrinterId] = useState(
    deployment?.config?.printer?.id || '',
  );
  const [error, setError] = useState(true);

  const handlePrinterIdChange = (event) => {
    setPrinterId(event.target.value);
  };
  const rolePermissions = {
    printjob: {
      read: true,
      create: true,
      update: true,
    },
    file: {
      read: true,
    },
  };

  const handleSave = async () => {
    if (!deployment) {
      const { data } = await tenant.post('/role', {
        permissions: rolePermissions,
      });
      if (!printerId || !data.insertedId) {
        setError(true);
      } else {
        setError(false);
        onSave({ printer: { role: data?.insertedId, id: printerId } });
      }
    } else {
      if (!printerId) {
        setError(true);
      } else {
        setError(false);
        onSave({
          printer: { role: deployment?.config?.printer?.role, id: printerId },
        });
      }
    }
  };

  useEffect(() => {
    if (!printerId) {
      setError(true);
    } else {
      setError(false);
    }
  }, [printerId]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ my: 1, mb: 2, pr: '80px' }}>
        <Typography variant="h6">Druckerkonfiguration</Typography>
        <Divider />
      </Box>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Geben Sie den Namen des Druckers ein, der für{' '}
        {app?.title || deployment?.title} verwendet werden soll.
      </Typography>

      <TextField
        fullWidth
        label="Drucker-ID"
        value={printerId}
        onChange={handlePrinterIdChange}
        inputProps={{ maxLength: 20 }}
        error={error}
        helperText={error ? 'Bitte geben Sie eine Drucker-ID ein' : ''}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 'auto', ml: 'auto' }} // This pushes the button to the bottom right
      >
        Speichern
      </Button>
    </Box>
  );
};

export default WarehousePrinterSettings;
